export default {
  FB_APP_ID: '113010648761829',
};

export type ShareQueryParameter = {
  ogImageUrl?: string;
  ogDescription?: string;
};
